<template>
  <div class="chartOne">
    <div :id="codMain" class="codMain"></div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    codMain: String,
    ChartData: Array,
  },
  data() {
    return {
      codChart: null,
      myChart: null,
      chartData: {},
      seriesData: [],
      openIndex: null,
      chartTitle: "",
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      this.getPie();
    });
    window.addEventListener("resize", this.handleResize);
  },
  watch: {
    ChartData(newval) {
      if (newval && newval.length > 0) {
        this.getPie();
      }
    },
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear();
      this.myChart.dispose();
    }
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    getPie() {
      // 检查数据和DOM元素是否存在
      if (!this.ChartData || !this.ChartData.length) {
        return;
      }

      const domElement = document.getElementById(this.codMain);
      if (!domElement) {
        return;
      }

      // 初始化或获取图表实例
      if (!this.myChart) {
        this.myChart = this.$echarts.init(domElement);
      }

      const option = {
        title: {},
        tooltip: {
          trigger: 'item'
        },
        color: ['rgba(255, 99, 71, 1)', 'rgba(36, 102, 168, 1)'],
        series: {
          type: "pie",
          radius: ["40%", "55%"],
          center: ["50%", "50%"],
          data: this.ChartData,
          label: {
            alignTo: 'edge',
            formatter: params => {
              if (!params || !params.data) {
                return '';
              }
              return `{name|${params.name}}\n{value|${params.data.number}}\n{percent|${params.data.value}%}`;
            },
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 30,
            fontSize: 15,
            color: '#999',
            padding: [0, 0, 0, 0],
            rich: {
              name: {
                fontSize: 15,
                color: '#4D4A4A',
                padding: [-10, 0, 20, 0],
              },
              value: {
                fontSize: 18,
                color: 'rgba(242, 242, 242, 1)',
                padding: [-10, 0, 10, 0],
              },
              percent: {
                fontSize: 20,
                fontWeight: 600,
                color: 'inherit',
                padding: [-10, 0, 10, 0],
              }
            }
          },
          labelLine: {
            length: 15,
            length2: 0,
            maxSurfaceAngle: 80
          },
          labelLayout: (params) => {
            if (!this.myChart) {
              return {};
            }
            const isLeft = params.labelRect.x < this.myChart.getWidth() / 2;
            const points = params.labelLinePoints;
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width;
            return {
              labelLinePoints: points
            };
          },
        },
      };

      this.myChart.setOption(option, true);
    },
  },
};
</script>

<style lang="scss" scoped>
.chartOne {
  width: 100%;
  margin: 0 auto;

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .codMain {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }

  h4 {
    padding-top: 10px;
    padding-left: 36px;
    font-size: 16px;
    color: rgb(76, 76, 76);
  }
}
</style>
